<p-datepicker
    [inputId]="inputId"
    [ngModel]="value"
    (ngModelChange)="onRangeChange($event)"
    selectionMode="range"
    [numberOfMonths]="1"
    [readonlyInput]="true"
    [maxDate]="maxSelectableDate"
    [monthNavigator]="true"
    [yearNavigator]="true"
    [yearRange]="yearRange"
    dateFormat="dd-mm-yy"
    appendTo="body"
    [disabled]="disabled"
    [attr.data-test]="dataTest"
    fluid
>
    <ng-template #footer>
        <div class="date-range-picker-presets" data-test="date-range-picker-presets">
            @for (preset of presets; track preset.label) {
                <p-button
                    [label]="preset.label"
                    [severity]="isPresetActive(preset) ? 'primary' : 'secondary'"
                    [text]="!isPresetActive(preset)"
                    size="small"
                    [attr.data-test]="'date-range-picker-preset-' + preset.label"
                    [attr.data-active]="isPresetActive(preset) || null"
                    (onClick)="onPresetSelect(preset)"
                />
            }
        </div>
    </ng-template>
</p-datepicker>
